/* Ryse - Theoric: ATIVOS do miolo da PDP — acordeao horizontal nas duas telas.

   Desktop: as 5 colunas cabem juntas; a ativa cresce.
   Mobile: janela de dois — a ativa ocupa ~72% e a seguinte fica de pe ao lado.

   AUTOPLAY: mais lento no mobile (INTERVALO_MOBILE) do que no desktop (INTERVALO).
   A interacao pausa por 9s e ele VOLTA sozinho — inclusive no mobile.

   POR QUE VOLTAVA A NAO ANDAR NO MOBILE (corrigido):
   1) "mouseenter" dispara no TOQUE e "mouseleave" nunca chega, entao o guarda
      "mouse em cima" ficava preso em true. Agora so contam ponteiros de MOUSE.
   2) Ao tocar num card ele ganha foco (role=button/tabindex) e o foco nao sai,
      entao o guarda de teclado bloqueava pra sempre. Agora esse guarda so vale
      quando a ultima interacao foi de TECLADO. */
(function () {
  var INTERVALO = 5200;
  var INTERVALO_MOBILE = 8000;
  var RETOMA = 9000;
  var ESPERA_MAX = 560;
  var DESTRAVA = 380;

  function iniciar() {
    var miolo = document.getElementById('theoric-pdp-miolo');
    if (!miolo) return;
    var trilho = miolo.querySelector('[data-tpn-trilho]');
    if (!trilho) return;
    var cards = [].slice.call(trilho.querySelectorAll('.tpn__card'));
    if (!cards.length) return;

    var mqReduz = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mqMobile = window.matchMedia('(max-width: 989px)');
    var pausadoAte = 0;
    var mouseEmCima = false;
    var naTela = true;
    var ativo = 0;
    var versao = 0;
    var travado = false;
    var tDestrava;
    var ultimaEntrada = 'ponteiro';   // 'ponteiro' | 'teclado'

    document.addEventListener('keydown', function () { ultimaEntrada = 'teclado'; }, true);
    document.addEventListener('pointerdown', function () { ultimaEntrada = 'ponteiro'; }, true);
    document.addEventListener('touchstart', function () { ultimaEntrada = 'ponteiro'; }, { capture: true, passive: true });

    cards.forEach(function (card) {
      if (card.querySelector('.tpn__card-vert')) return;
      var nome = card.querySelector('.tpn__card-nome');
      if (!nome) return;
      var v = document.createElement('span');
      v.className = 'tpn__card-vert';
      v.setAttribute('aria-hidden', 'true');
      v.textContent = nome.textContent;
      card.appendChild(v);
    });

    var pontos = document.createElement('div');
    pontos.className = 'tpn__pontos';
    pontos.setAttribute('role', 'group');
    pontos.setAttribute('aria-label', 'Ativos da fórmula');
    cards.forEach(function (card, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tpn__ponto';
      b.setAttribute('aria-label', 'Ver ativo ' + (i + 1));
      b.addEventListener('click', function () { adiar(); destacar(i); });
      pontos.appendChild(b);
    });
    trilho.parentNode.insertBefore(pontos, trilho.nextSibling);

    function marcarPontos() {
      for (var i = 0; i < pontos.children.length; i++) {
        var e = i === ativo;
        pontos.children[i].classList.toggle('is-ponto-ativo', e);
        if (e) pontos.children[i].setAttribute('aria-current', 'true');
        else pontos.children[i].removeAttribute('aria-current');
      }
    }

    function alinhar() {
      var card = cards[ativo];
      var delta = card.getBoundingClientRect().left - trilho.getBoundingClientRect().left;
      if (Math.abs(delta) > 2) {
        trilho.scrollTo({ left: trilho.scrollLeft + delta, behavior: 'smooth' });
      }
    }

    function travar(ms) {
      travado = true;
      clearTimeout(tDestrava);
      tDestrava = setTimeout(function () { travado = false; }, ms);
    }

    function corrigir() {
      versao++;
      travar(DESTRAVA);
      alinhar();
    }

    function destacar(i, semRolar) {
      ativo = (i + cards.length) % cards.length;
      versao++;
      var minhaVersao = versao;

      for (var n = 0; n < cards.length; n++) {
        var e = n === ativo;
        cards[n].classList.toggle('is-card-ativo', e);
        cards[n].setAttribute('aria-expanded', e ? 'true' : 'false');
      }
      marcarPontos();
      if (semRolar) return;

      travado = true;
      clearTimeout(tDestrava);

      var card = cards[ativo];
      var jaAlinhou = false;

      function agora() {
        if (jaAlinhou || minhaVersao !== versao) return;
        jaAlinhou = true;
        card.removeEventListener('transitionend', aoFim);
        alinhar();
        tDestrava = setTimeout(function () {
          if (minhaVersao === versao) travado = false;
        }, DESTRAVA);
      }
      function aoFim(ev) {
        if (ev.target !== card) return;
        if (ev.propertyName === 'flex-basis' || ev.propertyName === 'flex-grow') agora();
      }

      card.addEventListener('transitionend', aoFim);
      setTimeout(agora, ESPERA_MAX);
    }

    cards.forEach(function (card, i) {
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.addEventListener('click', function () { adiar(); destacar(i); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); adiar(); destacar(i); }
      });
    });

    function maisProximo() {
      var borda = trilho.getBoundingClientRect().left;
      var alvo = 0, menor = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(cards[i].getBoundingClientRect().left - borda);
        if (d < menor) { menor = d; alvo = i; }
      }
      return alvo;
    }

    var tArrasto;
    trilho.addEventListener('scroll', function () {
      if (travado) return;
      clearTimeout(tArrasto);
      tArrasto = setTimeout(function () {
        if (travado) return;
        var alvo = maisProximo();
        if (alvo !== ativo) destacar(alvo);
        else corrigir();
      }, 150);
    }, { passive: true });

    function podeAndar() {
      if (mqReduz.matches) return false;
      if (document.hidden || !naTela) return false;
      if (mouseEmCima) return false;
      /* foco so bloqueia se a pessoa estiver navegando por TECLADO — no toque
         o card fica focado e isso NAO deve travar o autoplay */
      if (ultimaEntrada === 'teclado' && trilho.contains(document.activeElement)) return false;
      if (Date.now() < pausadoAte) return false;
      return true;
    }
    function passo() { if (podeAndar()) destacar(ativo + 1); }
    function adiar() { pausadoAte = Date.now() + RETOMA; }

    ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (ev) {
      trilho.addEventListener(ev, adiar, { passive: true });
    });
    /* SO mouse mexe no guarda "mouse em cima" — toque nao */
    trilho.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') mouseEmCima = true; });
    trilho.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { mouseEmCima = false; adiar(); } });
    pontos.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') mouseEmCima = true; });
    pontos.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { mouseEmCima = false; adiar(); } });

    var navs = miolo.querySelectorAll('.tpn__navbtn');
    for (var k = 0; k < navs.length; k++) navs[k].addEventListener('click', adiar);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        naTela = ents[0].isIntersecting;
      }, { threshold: 0.1 }).observe(trilho);
    }

    /* autoplay: intervalo diferente por tela; reavalia ao cruzar o breakpoint */
    var timer = null;
    function ligarTimer() {
      if (timer) clearInterval(timer);
      if (mqReduz.matches) return;
      var ms = mqMobile.matches ? INTERVALO_MOBILE : INTERVALO;
      timer = setInterval(passo, ms);
    }

    var tResize;
    window.addEventListener('resize', function () {
      clearTimeout(tResize);
      tResize = setTimeout(function () { destacar(ativo); ligarTimer(); }, 220);
    }, { passive: true });

    destacar(0, true);
    ligarTimer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
